import { render, staticRenderFns } from "./online-course.vue?vue&type=template&id=25cbb19e&scoped=true"
import script from "./online-course.vue?vue&type=script&lang=js"
export * from "./online-course.vue?vue&type=script&lang=js"
import style0 from "./online-course.vue?vue&type=style&index=0&id=25cbb19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cbb19e",
  null
  
)

export default component.exports